import React from 'react';
import i18next from 'i18next';

import {Icon} from '@famly/mf_data-display_icon';
import {Text} from '@famly/mf_data-display_text';
import {Stack} from '@famly/mf_layout_stack';
import {showDialog} from 'web-app/react/dialog';

type Scope = 'posts' | 'messages';

export const showSmsConfirmationDialog = (props: {
    onSubmit: VoidFunction;
    onCancel: VoidFunction;
    scope: Scope;
    priceWarning: string;
}) => {
    const dialogTitle =
        props.scope === 'posts'
            ? i18next.t('sms.confirmationDialog.titleForPosts')
            : i18next.t('sms.confirmationDialog.titleForMessages');
    const dialogDescription =
        props.scope === 'posts'
            ? i18next.t('sms.confirmationDialog.descriptionForPosts')
            : i18next.t('sms.confirmationDialog.descriptionForMessages');

    return showDialog({
        title: dialogTitle,
        children: (
            <>
                <Text variant="body" emphasized mb={2}>
                    {props.priceWarning}
                </Text>
                <Text variant="body" mb={4}>
                    {dialogDescription}
                </Text>
                {props.scope === 'posts' && (
                    <Stack spacing={2} mb={4}>
                        <Icon name="edit" color="b400" size={20} />
                        <Text variant="body-small">{i18next.t('sms.confirmationDialog.editPostInfoBullet')}</Text>
                    </Stack>
                )}
                <Stack spacing={2}>
                    <Icon name="holiday_village" color="p300" size={20} />
                    <Text variant="body-small">{i18next.t('sms.confirmationDialog.multipleDaycaresInfoBullet')}</Text>
                </Stack>
            </>
        ),
        type: 'mf',
        okText: 'Confirm',
        'data-e2e-id': 'sms-warning-dialog',
    }).then(choice => {
        if (choice === 'OK') {
            props.onSubmit();
        } else if (choice === 'CANCEL') {
            props.onCancel();
        }

        return choice;
    });
};
